import React from 'react';
import './Loginpage.css';
import { setUserLog,setUserOut} from './userSlice';
import {useSelector,useDispatch} from 'react-redux';
import {getAuth,signInWithPopup,GoogleAuthProvider} from "firebase/auth";
import {provider,auth} from './Firebase';
function Loginpage() {
    const dispatch=useDispatch();
    const signIn=()=>{
        signInWithPopup(auth,provider).then(result=>{dispatch(setUserLog({name:result.user.displayName,email:result.user.email,
        photo:result.user.photoURL
        
        }))}).catch((err)=>console.log(err))
        }
        const signOut=()=>{
            auth.signOut().then(()=>{dispatch(setUserOut());});
        }


  return <div className="login">
<div className="login_container">
<img src="/images/whatsappfavicon.jpg" style={{background:'white'}}/>
<div className="login_text">
    <h2>Sign in to WhatsApp Clone</h2>
</div>
<button onClick={()=>{signIn()}}>Sign In With Google</button>
</div>



  </div>;
}

export default Loginpage;
